<template>
    <a class="shop-text" :href="shopLink">
        <div class="img">
            <span v-if="counter > 0" class="carrello-nr" v-text="counter"></span>
            <img src="/img/frontend/sl-icon-03.svg">
        </div>
        <span>Shop</span>
    </a>
</template>
<style  scoped>

    .carrello-nr{
        bottom: -8px;
        font-size: 12px;
    }

</style>
<script>
export default {
    props: ['initCounter', 'cartLink', 'shopLink'],
    data() {
        return {
            counter: 0
        }
    },
    mounted() {
        this.counter = parseInt(this.initCounter);
        this.$eventHub.$on('cart.added', payload => {
            this.counter = parseInt(payload.count);
        });

        this.$eventHub.$on('cart.updated.simpleQty', payload => {
            this.counter = payload;
        });
    },
    beforeDestroy() {
        this.$eventHub.$off('cart.added');
        this.$eventHub.$off('cart.updated.simpleQty');
    },
}
</script>
